import { IApplicationState } from '@bridebook/web/lib/types';

export const getSnackbarState = (state: IApplicationState) => state.bbcommon.snackbarState;

export const getOpenedModalIds = (state: IApplicationState) => state.bbcommon.openedModalIds;

export const getIsModalOpened = (modalId: string) => (state: IApplicationState) =>
  getOpenedModalIds(state).includes(modalId);

export const getIsAnyModalVisible = (state: IApplicationState) =>
  state.bbcommon.openedModalIds.length > 0;
